module.exports = __webpack_public_path__ + "cc0202a94bc8560a7005814401ef9247.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/bg.png
// module id = ./app/images/bg.png
// module chunks = 35